import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
  Heart,
  Stethoscope,
  Shield,
  Award,
  Users,
  TrendingUp,
  Clock,
  ChevronLeft,
  Star,
  Activity,
  Brain,
  Baby,
  Calendar,
  MapPin,
  Phone
} from 'lucide-react';
import './Home.css';

const stats = [
  // { icon: Users, value: '10,000+', label: 'مريضة سعيدة' },
  { icon: Award, value: '20+', label: 'سنة خبرة' },
  { icon: TrendingUp, value: '98%', label: 'نسبة النجاح' },
  // { icon: Star, value: '4.9', label: 'تقييم المرضى' },
];

const services = [
  {
    icon: Baby,
    title: 'متابعة الحمل والحمل الحرج',
    desc: 'متابعة دقيقة لجميع مراحل الحمل بأحدث التقنيات الطبية والأجهزة المتطورة.',
  },
  {
    icon: Activity,
    title: 'علاج تأخر الحمل',
    desc: 'تشخيص وعلاج أسباب تأخر الحمل باستخدام أحدث البروتوكولات العلاجية العالمية.',
  },
  {
    icon: Brain,
    title: 'تقنيات الإخصاب المساعد (ICSI)',
    desc: 'حقن مجهري متقدم بأعلى معدلات نجاح بفضل الخبرة والتقنيات الحديثة.',
  },
  {
    icon: Shield,
    title: 'التشخيص الوراثي للأجنة (PGD)',
    desc: 'فحص الأجنة قبل الانغماس لضمان صحة الجنين وتجنب الأمراض الوراثية.',
  },
  {
    icon: Stethoscope,
    title: 'المناظير الجراحية الدقيقة',
    desc: 'المناظير الجراحية الدقيقة لتشخيص وعلاج العديد من الحالات بدقة عالية.',
  },
  {
    icon: Heart,
    title: 'استشارات صحة المرأة والصحة الإنجابية',
    desc: 'استشارات متخصصة في مجال صحة المرأة والصحة الإنجابية.',
  },
];

const testimonials = [
  {
    name: 'سارة أحمد',
    role: 'مريضة',
    text: 'تجربة رائعة مع الدكتور محمد، شعرت بالراحة والأمان من أول لحظة. الحمد لله حملت بعد سنوات من المحاولة بفضل خبرته العظيمة.',
    rating: 5,
  },
  {
    name: 'نورا محمود',
    role: 'مريضة',
    text: 'أفضل دكتور قابلته في حياتي، يتميز بالصبر والاهتمام الشديد بكل تفاصيل الحالة. أنصح الجميع بزيارته.',
    rating: 5,
  },
  {
    name: 'فاطمة عبدالله',
    role: 'مريضة',
    text: 'بعد سنوات من المعاناة مع تأخر الحمل، وجدت الحل مع الدكتور محمد. شكراً من القلب على رعايتكم المتميزة.',
    rating: 5,
  },
];

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-50px' },
  transition: { duration: 0.6 },
};

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-gradient"></div>
          <div className="hero-particles">
            {[...Array(20)].map((_, i) => (
              <div
                key={i}
                className="particle"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 5}s`,
                  animationDuration: `${5 + Math.random() * 5}s`,
                }}
              />
            ))}
          </div>
        </div>

        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-badge"
          >
            <Award size={16} />
            <span>استشاري النساء والتوليد</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hero-title"
          >
            رعايتكِ
            <span className="hero-title-accent"> في أيدٍ أمينة</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="hero-subtitle"
          >
            نقدم أعلى مستويات الرعاية الطبية المتخصصة في مجال النساء والتوليد
            باستخدام أحدث التقنيات العالمية في علاج تأخر الحمل والحقن المجهري.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="hero-buttons"
          >
            <Link to="/booking">
              <motion.button
                className="btn-hero-primary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                احجزي موعدكِ الآن
                <ChevronLeft size={18} />
              </motion.button>
            </Link>
            <Link to="/about">
              <motion.button
                className="btn-hero-secondary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                تعرفي على الدكتور
              </motion.button>
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1 }}
            className="hero-stats"
          >
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                className="hero-stat"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.2 + index * 0.15 }}
              >
                <stat.icon size={24} className="stat-icon" />
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>

        <div className="hero-image">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
            className="hero-image-wrapper"
          >
            <div className="hero-image-glow"></div>
            <img
              src='/Assets/WhatsApp Image 2026-07-12 at 1.14.36 PM.jpeg'
              alt="د. محمد خالد توفيق"
              className="hero-img"
            />
            <div className="hero-image-ring"></div>
          </motion.div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section" id="services">
        <div className="section-container">
          <motion.div {...fadeInUp} className="section-header">
            <span className="section-badge">خدماتنا</span>
            <h2 className="section-title">خدمات طبية متكاملة</h2>
            <p className="section-subtitle">
              نقدم مجموعة شاملة من الخدمات الطبية المتخصصة في مجال النساء والتوليد
            </p>
          </motion.div>

          <div className="services-grid">
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                {...fadeInUp}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="service-card"
                whileHover={{ y: -10 }}
              >
                <div className="service-icon-wrapper">
                  <service.icon size={28} className="service-icon" />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-desc">{service.desc}</p>
                <Link to="/booking" className="service-link">
                  احجزي الآن <ChevronLeft size={14} />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-section">
        <div className="section-container">
          <div className="why-grid">
            <motion.div {...fadeInUp} className="why-image">
              <img
                src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=500&h=600&fit=crop"
                alt="عيادة النساء والتوليد"
                className="why-img"
              />
              <div className="why-image-overlay"></div>
            </motion.div>

            <motion.div {...fadeInUp} className="why-content">
              <span className="section-badge">لماذا نحن</span>
              <h2 className="section-title">نختلف لنميز</h2>
              <p className="why-text">
                نؤمن أن كل مريضة تستحق أفضل رعاية طبية ممكنة. لهذا السبب نستثمر باستمرار
                في تطوير فريقنا الطبي وتقنياتنا الطبية لتقديم نتائج استثنائية في مجال النساء والتوليد.
              </p>

              <div className="why-features">
                {[
                  { icon: Shield, title: 'أعلى معايير السلامة', desc: 'نلتزم بأشد معايير السلامة والتعقيم العالمية.' },
                  { icon: Clock, title: 'مواعيد دقيقة', desc: 'نحترم وقتكِ ونلتزم بالمواعيد المحددة بدقة.' },
                  { icon: Heart, title: 'رعاية شخصية', desc: 'نهتم بكل مريضة كفرد فريد لها احتياجات خاصة.' },
                ].map((feature, index) => (
                  <motion.div
                    key={feature.title}
                    className="why-feature"
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.2 }}
                  >
                    <div className="why-feature-icon">
                      <feature.icon size={22} />
                    </div>
                    <div>
                      <h4>{feature.title}</h4>
                      <p>{feature.desc}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="section-container">
          <motion.div {...fadeInUp} className="section-header">
            <span className="section-badge">آراء المرضى</span>
            <h2 className="section-title">ما يقوله مرضانا</h2>
          </motion.div>

          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.name}
                {...fadeInUp}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                className="testimonial-card"
              >
                <div className="testimonial-stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={16} fill="#c9a84c" color="#c9a84c" />
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <div className="testimonial-avatar">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <h4>{testimonial.name}</h4>
                    <span>{testimonial.role}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-bg">
          <div className="cta-gradient"></div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="cta-content"
        >
          <Heart size={48} className="cta-icon" />
          <h2>صحتكِ تستحق الأفضل</h2>
          <p>لا تترددي في حجز موعدكِ الآن والحصول على أفضل رعاية طبية متخصصة</p>
          <Link to="/booking">
            <motion.button
              className="btn-cta"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              احجزي موعدكِ الآن
              <ChevronLeft size={18} />
            </motion.button>
          </Link>
        </motion.div>
      </section>
    </div>
  );
};

export default Home;